import { IInitialState } from "us.collection.case/reducers/MassageTemplates/Interfaces";

export const messageTemplateInitial = {
  id: 0,
  application: "",
  templateCategory: "",
  templateName: "",
  plugin: "",
  isPin: false,
  displayName: "",
  templateId: 0
};

export const initialState: IInitialState = {
  messageTemplates: {
    data: [],
    isLoading: false,
  },
  previewEditDrawerData: {
    title: "",
    visible: false,
    isPreview: false,
    messageTemplate: messageTemplateInitial,
  },
  template: {
    communicationJobId: 0,
    content: [],
    isLoading: false,
  },
  emailDrawerData: {
    title: "",
    visible: false,
  },
  generateMessageData: {
    communicationJobId: 0,
    generatedMessgePath: "",
    isLoading: false,
  },
  email: {
    isLoading: false,
  },
  tempalateUpdatedContent: [],
  messageTemplateContent: {
    data: {},
    isLoading: false
  },
  templateDrawer: {
    title: "",
    visible: false,
    type: "",
    isPreview: false,
    templateDetails: messageTemplateInitial
  },
  isEmailSending: false,
  isTemplateExecuting: false,
  templateVersionBMDs: []
};
